const fr = {
  nav: {
    home: "Accueil",
    services: "Services",
    resources: "Ressources",
    accompagnement: "Accompagnement",
    bookCall: "Réserver un appel",
    openMenu: "Ouvrir le menu",
    closeMenu: "Fermer le menu",
    svc: {
      reels: { name: "Reels & TikTok", desc: "Vidéos courtes percutantes" },
      podcasts: { name: "Podcasts", desc: "Production audio professionnelle" },
      events: { name: "Événements", desc: "Captation événementielle" },
      formations: { name: "Formations", desc: "Cours en ligne clé en main" },
      ads: { name: "Publicités", desc: "Ads Meta, YouTube, TikTok" },
    },
    res: {
      cases: { name: "Études de cas", desc: "Résultats clients prouvés" },
      articles: { name: "Articles", desc: "Guides et conseils marketing" },
      portfolio: { name: "Portfolio", desc: "Nos réalisations vidéo" },
    },
  },
  hero: {
    eyebrow: "L'agence créative de confiance des entrepreneurs ambitieux",
    title1: "Partenaire de croissance",
    title2: "qui bâtit des",
    titleEm: "systèmes prévisibles.",
    subtitle:
      "On bâtit des systèmes avec la création de contenu organique et la puissance des publicités payantes.",
    cta: "Réserver un appel gratuit",
  },
  services: {
    title1: "On fait croître votre entreprise avec les ",
    titleEm: "réseaux sociaux",
    intro:
      "Générer de la visibilité. Convertir des leads. Augmenter le revenu. Garanti.",
    items: [
      {
        title: "Identifier les goulots d'étranglement",
        description:
          "On analyse votre entreprise pour voir où se trouvent vos plus grandes opportunités. Ça nous donne la fondation d'une stratégie sur mesure pour votre entreprise.",
      },
      {
        title: "Bâtir votre système marketing",
        description:
          "On bâtit des systèmes évolutifs pour les réseaux sociaux, la publicité de performance et la croissance organique, pour que vous puissiez croître de façon prévisible.",
      },
      {
        title: "Lancer, tester et scaler",
        description:
          "On lance les campagnes, on teste des variations et on optimise la performance en continu, en doublant sur ce qui génère vues, engagement et conversions pour que la croissance compose dans le temps.",
      },
      {
        title: "Croissance garantie",
        description:
          "Vous obtenez une transparence complète sur la performance pour assurer l'atteinte des cibles. Le tout appuyé par notre garantie de performance.",
      },
    ],
  },
  portfolio: {
    badge: "Nos expertises",
    title1: "De l'idéation à la ",
    titleEm: "diffusion",
    intro:
      "Nous vous accompagnons du premier brainstorming jusqu'à la publication finale, avec une seule mission : créer un contenu qui attire, engage… et convertit.",
    tagline: "Stratégie. Création. Diffusion. Optimisation.",
    cta: "Découvrir nos réalisations",
    categories: {
      reels: "Reels",
      podcasts: "Podcasts",
      events: "Événements",
      formations: "Formations en ligne",
      ads: "Publicités",
    },
    content: {
      reels: {
        title: "Reels",
        description:
          "Chez Agence 8020, nous maîtrisons l'art de créer des vidéos courtes qui captent l'attention dès les premières secondes. Conçues pour les réseaux sociaux, nos vidéos verticales racontent votre histoire avec impact et authenticité, tout en maximisant votre portée et votre engagement.",
        highlight:
          "En quelques secondes, vous faites passer le bon message, au bon public, sur les bonnes plateformes.",
      },
      podcasts: {
        title: "Podcasts",
        description:
          "Dans un monde où chaque seconde compte, les podcasts offrent un moyen puissant de partager des histoires et des idées significatives. Chez Agence 8020, nous créons des expériences audio courtes, engageantes et percutantes, conçues pour captiver votre audience.",
        highlight:
          "Notre équipe allie stratégie et storytelling créatif pour produire des podcasts qui informent, inspirent et construisent des connexions durables avec vos auditeurs.",
      },
      events: {
        title: "Événements",
        description:
          "Chaque événement mérite d'être raconté avec émotion et authenticité. Chez Agence 8020, nous capturons l'énergie, les moments forts et les interactions qui rendent votre événement unique. Qu'il s'agisse d'un récapitulatif dynamique, d'une vidéo promotionnelle ou d'une captation complète, notre équipe s'adapte à votre vision et à votre environnement.",
        highlight:
          "Notre objectif : transformer vos moments en histoires mémorables qui continuent de rayonner bien après la fin de l'événement.",
      },
      formations: {
        title: "Formations en ligne",
        description:
          "Transformez votre expertise en un outil de croissance. Chez Agence 8020, nous vous aidons à concevoir, structurer et produire vos formations en ligne avec clarté et impact. Nos vidéos sont créées pour rendre votre enseignement captivant et accessible, tout en reflétant votre professionnalisme.",
        highlight:
          "Que vous souhaitiez tourner dans notre studio ou dans votre propre environnement, nous vous accompagnons à chaque étape pour offrir une expérience d'apprentissage fluide, engageante et humaine.",
      },
      ads: {
        title: "Publicités",
        description:
          "En plus de la création de contenu organique, nous produisons des publicités vidéo performantes pour les plateformes comme Meta (Facebook/Instagram), YouTube et TikTok. Notre approche allie stratégie, storytelling et optimisation publicitaire.",
        highlight:
          "Nous pouvons gérer l'idéation, la production et la diffusion de vos campagnes selon vos objectifs de visibilité ou de conversion.",
      },
    },
  },
  process: {
    badge: "On lance rapidement",
    title1: "Du premier contact aux ",
    titleEm: "résultats",
    intro1: "Dans un monde où tout bouge vite, votre contenu doit bouger encore plus vite.",
    intro2:
      "Notre processus est conçu pour passer de l'idée au contenu publié en un temps record. Pas de réunions interminables, pas de délais qui s'éternisent. Juste du contenu qui performe.",
    estimated: "Temps estimé",
    ctaPrefix: "Prêt à démarrer? ",
    cta: "Réserver un appel",
    milestoneEyebrow: "Mise en ligne",
    milestoneTitle1: "Lancement en ",
    milestoneTitleEm: "7 jours",
    milestoneDesc:
      "Une semaine après le premier appel, votre système tourne : contenu en production, campagnes actives, conversion en place. Pas de délai de six mois, pas d'excuses.",
    steps: [
      {
        title: "Appel découverte",
        description:
          "On apprend à se connaître. On écoute vos objectifs, votre vision et on détermine si le fit est là.",
        duration: "1h",
      },
      {
        title: "Stratégie",
        description:
          "On fait une analyse approfondie de votre marque, votre audience et votre marché pour bâtir une stratégie sur mesure.",
        duration: "2 jours",
      },
      {
        title: "Création & Production",
        description:
          "Tournage structuré, montage dynamique et des publicités qui performent. Du contenu qui arrête le scroll.",
        duration: "5 jours",
      },
      {
        title: "Lancement",
        description:
          "Publication stratégique sur vos plateformes aux moments optimaux pour maximiser la portée.",
        duration: "Immédiat",
      },
      {
        title: "Optimisation",
        description:
          "Analyse des performances, ajustements et itérations pour des résultats toujours meilleurs.",
        duration: "Mensuel",
      },
    ],
  },
  results: {
    badge: "Nos résultats",
    title1: "Des chiffres qui ",
    titleEm: "parlent",
    intro: "Notre expertise se traduit par des résultats concrets pour nos clients",
    stats: [
      { label: "Vues générées", description: "Sur les réseaux sociaux" },
      { label: "Clients satisfaits", description: "Qui nous font confiance" },
      { label: "Vidéos produites", description: "Contenu créé pour nos clients" },
      { label: "ROI moyen", description: "Retour sur investissement" },
    ],
  },
  testimonials: {
    title1: "Ce que nos clients ",
    titleEm: "pensent",
    intro:
      "Découvrez ce que nos clients pensent de leur expérience avec nous. Des avis authentiques, des histoires réelles et des retours honnêtes.",
  },
  partners: { title: "Ils nous font confiance, serez-vous le prochain?" },
  faq: {
    title1: "Foire aux questions ",
    titleEm: "(FAQ's)",
    items: [
      {
        question: "Quels sont vos services ?",
        answer: `Nous offrons un accompagnement complet en création de contenu vidéo et en stratégie de diffusion.

Nos principaux services incluent :
• Vidéos verticales pour les réseaux sociaux
• Podcasts, en studio ou en déplacement
• Captation et couverture d'événements
• Formations en ligne
• Publicités vidéo conçues pour la performance

En résumé, nous créons le contenu qui attire, engage et convertit, que ce soit pour bâtir votre marque, générer des clients ou inspirer votre communauté.`,
      },
      {
        question: "Combien coûte un mandat avec l'Agence 8020 ?",
        answer: `Nos mandats sont adaptés à chaque client selon ses besoins, ses objectifs et la portée du projet. Nous travaillons principalement sous forme de forfaits mensuels (retainership), qui incluent la stratégie, la création et la diffusion du contenu.

👉 Lors de notre premier appel, nous évaluons ensemble ce qui a le plus d'impact pour vous.`,
      },
      {
        question: "Est-ce que vous faites seulement de la vidéo ?",
        answer: `La vidéo est au cœur de notre expertise, mais notre accompagnement va au-delà. Nous aidons nos clients à bâtir une stratégie de contenu complète : structure de publication, positionnement de marque, idéation, et optimisation pour les réseaux sociaux.`,
      },
      {
        question: "Peut-on tourner ailleurs qu'à votre studio ?",
        answer: `Absolument.

Nous disposons d'un studio professionnel à Mascouche, mais notre équipe se déplace partout au Québec pour capturer vos contenus dans votre environnement ou lors d'événements.`,
      },
      {
        question: "Combien de temps prend un projet avant d'être diffusé ?",
        answer: `Tout dépend du format et du nombre de livrables, mais en général, une production complète (de la captation à la livraison) prend entre 7 et 14 jours ouvrables.

Pour les clients en forfait mensuel, un calendrier clair de tournage et de diffusion est établi dès le départ.`,
      },
      {
        question: "Faites-vous aussi de la publicité ?",
        answer: `Oui.

En plus de la création de contenu organique, nous produisons des publicités vidéo performantes pour les plateformes comme Meta (Facebook/Instagram), YouTube et TikTok.

Notre approche allie stratégie, storytelling et optimisation publicitaire, afin de transformer vos vidéos en véritables outils d'acquisition.

Nous pouvons gérer l'idéation, la production et la diffusion de vos campagnes selon vos objectifs de visibilité ou de conversion.`,
      },
    ],
  },
  contact: {
    title1: "Prêt à passer au ",
    titleEm: "niveau suivant?",
    intro:
      "<0>Réservez un appel découverte gratuit</0> pour discuter de votre projet et déterminer si l'Agence 8020 est le bon partenaire pour vous accompagner vers vos objectifs.",
    cta: "Réserver un appel gratuit",
    note: "Appel de 30 minutes • 100% gratuit",
  },
  footer: {
    tagline: "Accompagnement marketing pour entrepreneurs et professionnels ambitieux au Québec.",
    servicesTitle: "Services",
    guidesTitle: "Guides",
    followTitle: "Suivez-nous",
    accompagnement: "Accompagnement marketing",
    ourServices: "Nos services",
    pricing: "Tarifs",
    guideB2B: "Marketing de contenu B2B",
    guideCreation: "Création de contenu B2B",
    guideAgency: "Agence marketing B2B",
    guideVideo: "Marketing vidéo B2B",
    allArticles: "Tous les articles",
    privacy: "Politique de confidentialité",
    rights: "Tous droits réservés.",
  },
  langToggle: { label: "Langue", switchTo: "Switch to English" },
};
export default fr;
